import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerProject } from '../../customer-project.interface';
import { LocalStorage } from '../../local-storage.class';
import { Routenames } from '../../route-names.enum';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';

@Component({
    selector: 'app-workarea-project-choose-dialog',
    templateUrl: './workarea-project-choose-dialog.component.html',
    standalone: false,
})
export class WorkareaProjectChooseDialogComponent implements OnInit {
    projects: CustomerProject[];

    constructor(
        public dialogRef: MatDialogRef<WorkareaProjectChooseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public type: string,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private customerProjectService: CustomerProjectService
    ) {}

    ngOnInit(): void {
        if (this.activatedRoute.snapshot.queryParams['project']) {
            const route = [Routenames.customers, LocalStorage.getCustomer()['id'], Routenames.workareas, -1] as (
                | number
                | string
                | object
            )[];
            this.router.navigate(route, {
                queryParamsHandling: 'merge',
            });
            setTimeout(() => this.dialogRef.close());
        } else {
            this.customerProjectService.getProjects(false, LocalStorage.getCustomer()['id']).subscribe(projects => {
                this.projects = projects;

                if (this.projects.length === 1) {
                    this.create(this.projects[0]);
                }
                if (this.projects.length < 1) {
                    this.router.navigate(
                        [Routenames.customers, LocalStorage.getCustomer()['id'], Routenames.workareas, -1],
                        {
                            queryParamsHandling: 'merge',
                        }
                    );
                    this.dialogRef.close();
                }
            });
        }
    }

    create(project = null) {
        if (project) {
            this.router.navigate([Routenames.customers, project.customer_id, Routenames.workareas, -1], {
                queryParams: { project: project.id },
                queryParamsHandling: 'merge',
            });
        } else {
            const route = [Routenames.customers, LocalStorage.getCustomer().id, Routenames.workareas, -1] as (
                | number
                | string
                | object
            )[];
            this.router.navigate(route, {
                queryParamsHandling: 'merge',
            });
        }
        this.dialogRef.close();
    }
}
